export const blacklistedEmailsKey = 'blacklisted-emails';
